export default class IntelliProveUnsupportedBrowserError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, IntelliProveUnsupportedBrowserError.prototype);
  }
}
